class Nav {
    constructor() {
        $('[data-toggle-mobile-login]').on('click', e => {
            return this.toggleMobileLoginEventHandler(e);
        });

        $('[href="#toggle-menu"]').on('click', e => {
            return this.toggleMenuEventHandler(e);
        });

        $('.body-overlay').on('click', () => {
            return this.closeNav();
        });
    }

    toggleMobileLoginEventHandler(e) {
        e.preventDefault();
        return $('nav#mobile-menu .login-box').toggleClass('open');
    }

    closeMobileLogin() {
        return $('nav#mobile-menu .login-box').removeClass('open');
    }

    toggleMenuEventHandler() {
        if ($('body.nav-open').length) {
            return this.closeNav();
        }
        return this.openNav();

    }

    openNav() {
        return $('body').addClass('nav-open');
    }

    closeNav() {
        $('body').removeClass('nav-open');
        return this.closeMobileLogin();
    }

    positionNav() {
        const scrolled = $(window).scrollTop();

        const space = $('header nav').outerHeight();

        return $('header nav').css({
            'position': 'absolute',
            'top': `${ scrolled - space }px`,
        });
    }

    resetNavPosition() {
        return $('header nav').css({
            'position': '',
            'top': '',
        });
    }

    navOpacityChanger() {
        return $(window).scroll(() => {
            return this.navBackgroundScrollEventHandler();
        });
    }

    navBackgroundScrollEventHandler() {
        const scrolled = $(window).scrollTop();

        let opacity = scrolled / 200;

        if (opacity > 0.9) {
            opacity = 0.9;
        }

        return $('header nav').css({
            'background': `rgba(25, 116, 150, ${ opacity })`,
        });
    }
}

export default Nav;

